<script lang="ts" setup>
import Link from '@/components/Link.vue';
import type { DetailedAssignee } from '@/types/assignee';
import { defineProps } from 'vue';

defineProps<{
    detailedAssignee: DetailedAssignee;
}>();
</script>

<template>
    <Link
        v-if="detailedAssignee?._id"
        :route-to="{
            name: detailedAssignee?.type === 'Employee' ? 'employee' : 'team',
            params: {
                id: detailedAssignee?._id
            }
        }"
        :icon="detailedAssignee?.type === 'Employee' ? 'person' : 'group'"
        :displayText="detailedAssignee?.name"
    />
</template>

<style scoped></style>
